import React, { useEffect, useState } from "react";

import {
    getInventory
} from "../services/api";

import {
    Users,
    RefreshCw
} from "lucide-react";


const Customers = () => {

    const [customers, setCustomers] =
        useState([]);


    const load = async () => {

        try {

            const response =
                await getInventory();

            const inventory =
                response.data.data || [];


            const map = {};

            inventory.forEach(item => {

                const name =
                    item.customerName;

                if (!name) {
                    return;
                }


                if (!map[name]) {

                    map[name] = {
                        name,
                        bags: 0,
                        weight: 0,
                        lots: 0
                    };

                }


                map[name].bags +=
                    Number(
                        item.remainingBags || 0
                    );

                map[name].weight +=
                    Number(
                        item.remainingWeightTons || 0
                    );

                map[name].lots += 1;

            });


            setCustomers(
                Object.values(map)
            );

        } catch (err) {

            console.error(err);

        }

    };


    useEffect(() => {
        load();
    }, []);


    return (
        <div className="page-container">

            <div className="page-header">

                <div>

                    <h2>
                        Customers
                    </h2>

                    <p>
                        Customers currently storing stock
                    </p>

                </div>


                <button
                    className="primary-button"
                    onClick={load}
                >
                    <RefreshCw size={16} />
                    Refresh
                </button>

            </div>


            <div className="customers-grid">

                {customers.map(
                    customer => (

                        <div
                            className="content-card customer-card"
                            key={customer.name}
                        >

                            <div className="large-icon">
                                <Users />
                            </div>


                            <h3>
                                {customer.name}
                            </h3>


                            <div>
                                Lots:
                                {" "}
                                <strong>
                                    {customer.lots}
                                </strong>
                            </div>


                            <div>
                                Bags:
                                {" "}
                                <strong>
                                    {customer.bags.toLocaleString(
                                        "en-IN"
                                    )}
                                </strong>
                            </div>


                            <div>
                                Weight:
                                {" "}
                                <strong>
                                    {customer.weight.toFixed(2)}
                                    {" Tons"}
                                </strong>
                            </div>

                        </div>

                    )
                )}

            </div>


            {customers.length === 0 && (

                <div className="empty-state">
                    <Users size={35} />
                    <p>
                        No customers found.
                    </p>
                </div>

            )}

        </div>
    );
};


export default Customers;